import React from 'react';
import styled from '../../components/styled';
import Icon from '../../components/Icon';

interface LinkProps {
  name: string;
  handlePress: () => void;
}

const Link = ({ name, handlePress }: LinkProps) => {
  return (
    <Container onPress={handlePress}>
      <Name>{name}</Name>
      <NextIcon name="navigate-next" />
    </Container>
  );
};

export default Link;

const Container = styled.TouchableOpacity`
  flex: 1;
  background-color: white;
  padding: 20px;
  margin-top: 10px;
  border-radius: 4px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-direction: row !important;
`;

const Name = styled.Text`
  font-weight: bold;
`;

const NextIcon = styled(Icon)``;
